import React, { memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { GSIcon } from 'src/components/shared/GSIcon'

interface Props {
  onRefresh(): void
}

const AiReviewConfigsTableToolbarComponent = ({ onRefresh }: Props) => {
  // No search field: a partner has at most one configuration per document, so there is nothing
  // to search. Adding a configuration lives in the page header, matching the markets tab.
  return (
    <div
      css={tw`flex flex-row items-center gap-4 rounded-t-lg border-0 border-b border-t border-solid border-shades-100 bg-shades-0 px-4 py-3`}
    >
      <div css={tw`ml-auto`}>
        <Button
          size="small"
          color="white"
          leftIcon={<GSIcon iconName="gs_arrows_repeat" size={20} css={tw`text-shades-1000`} />}
          onClick={onRefresh}
          data-testid="ai-review-configs-refresh-button"
        >
          Refresh
        </Button>
      </div>
    </div>
  )
}

export const AiReviewConfigsTableToolbar = memo(AiReviewConfigsTableToolbarComponent)
